/** Drag type for reordering sections within the preview column */
export const NOTE_SECTION = "NOTE_SECTION";

/** Drag type for reordering items in sortable lists (POC, ICD-10, Problem List, etc.) */
export const LIST_ITEM = "LIST_ITEM";
